"use client"

import { Watch } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `WatchIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const WatchIcon = component(Icon)({ as: Watch })
